import { bodyClass, pageOverlayShow, pageOverlayHide } from './pageOverlay';

export default () => {
  const btn = document.getElementById('js-burger');
  const sidebar = document.getElementById('js-layout-mobile');

  if (btn && sidebar) {
    btn.addEventListener('click', () => {
      pageOverlayShow({
        onShow: () => {
          bodyClass.add('js-show-overlay-sb');
        },
      });
    });

    document.getElementById('js-btn-hide-mo').addEventListener('click', () => {
      pageOverlayHide({
        onHide: () => {
          bodyClass.remove('js-show-overlay-sb');
        },
      });
    });
  }
};
